import { defineMessages, MessageDescriptor } from "react-intl";

import { SyncAction } from "@app/models/SyncAction.ts";

interface SyncActionMessages {
  label: MessageDescriptor;
  description: MessageDescriptor;
}

export const syncActionMessages: Record<SyncAction, SyncActionMessages> = {
  SEND_USERS: defineMessages({
    label: {
      id: "settings.send_to_all_apps_users",
      defaultMessage: "Send users to everyone",
    },
    description: {
      id: "settings.send_to_all_apps_users.description",
      defaultMessage:
        "Publishes every user stored in the database to the listening applications, so they can refresh their copy of the employee directory.",
    },
  }),
  SEND_MISSIONS: defineMessages({
    label: {
      id: "settings.send_to_all_apps_missions",
      defaultMessage: "Send missions to everyone",
    },
    description: {
      id: "settings.send_to_all_apps_missions.description",
      defaultMessage:
        "Publishes every mission stored in the database to the listening applications, so they can refresh their copy of the missions.",
    },
  }),
  SYNC_IAM: defineMessages({
    label: {
      id: "settings.sync_with_iam",
      defaultMessage: "Synchronise with IAM",
    },
    description: {
      id: "settings.sync_with_iam.description",
      defaultMessage:
        "Matches each user with their Keycloak account by email, then updates their IAM identifier and roles.",
    },
  }),
  SYNC_ERP: defineMessages({
    label: {
      id: "settings.sync_with_erp",
      defaultMessage: "Synchronise with ERP",
    },
    description: {
      id: "settings.sync_with_erp.description",
      defaultMessage:
        "Fetches employees from SAP: refreshes jobs and departments, creates new users, updates the ones that changed and deactivates the ones no longer in SAP. Changes are published to the listening applications.",
    },
  }),
  SYNC_SALESFORCE_MISSIONS: defineMessages({
    label: {
      id: "settings.sync_missions",
      defaultMessage: "Synchronise missions with Salesforce",
    },
    description: {
      id: "settings.sync_missions.description",
      defaultMessage:
        "Fetches missions from Salesforce, creates or updates them in the database and publishes the changes to the listening applications.",
    },
  }),
  SYNC_MISSING_AVATARS: defineMessages({
    label: {
      id: "settings.sync_missing_avatars",
      defaultMessage: "Synchronise missing avatars",
    },
    description: {
      id: "settings.sync_missing_avatars.description",
      defaultMessage:
        "Looks for a profile picture in the Google Drive folder for every user who has no avatar yet.",
    },
  }),
};
